import * as React from "react";

function SvgCalendarDuo({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="#374151"
          d="M16 1.25a.75.75 0 01.743.648L16.75 2v1.25H19a2.75 2.75 0 012.745 2.582L21.75 6v13a2.75 2.75 0 01-2.582 2.745L19 21.75H5a2.75 2.75 0 01-2.745-2.582L2.25 19V6a2.75 2.75 0 012.582-2.745L5 3.25h2.25V2a.75.75 0 011.493-.102L8.75 2v1.25h6.5V2a.75.75 0 01.75-.75zm4.25 8.5H3.75V19c0 .648.491 1.18 1.122 1.244L5 20.25h14a1.25 1.25 0 001.244-1.122L20.25 19V9.75zM7.013 15.979l.117.007a1 1 0 11-.226-.002l.109-.005zm5 0l.117.007a1 1 0 11-.226-.002l.109-.005zm-5-4l.117.007a1 1 0 11-.226-.002l.109-.005zm5 0l.117.007a1 1 0 11-.226-.002l.109-.005zm5 0l.117.007a1 1 0 11-.226-.002l.109-.005z"
        />
        <path
          fill="#98DB69"
          d="M7.25 4.75H5a1.25 1.25 0 00-1.244 1.122L3.75 6v2.25h16.5V6a1.25 1.25 0 00-1.122-1.244L19 4.75h-2.25V6a.75.75 0 01-1.493.102L15.25 6V4.75h-6.5V6a.75.75 0 01-1.493.102L7.25 6V4.75z"
        />
      </g>
    </svg>
  );
}

export default SvgCalendarDuo;
